<template>
  <div :class="themeStyleVs === 2 ? 'hot_page black_version' : 'hot_page'" id="moniInfo" v-cloak>
    <header id="hdMain" :class="mainScrollShow ? 'sticky_header' : ''">
      <div class="header_main">
        <div class="navg_box" :style="`backdrop-filter: blur(${filterNum}px)`">
          <div class="bg_box">
            <navigation
              :text="'策略详情'"
              :searchShow="true"
              :shareImgShow="
                basicsObj &&
                basicsObj.isMn === true &&
                basicsObj.open_status == 1 &&
                basicsObj.ts_access == 2
              "
              :isMock="true"
              @shareBtn="shareBtn"
              :mark="mark"
            ></navigation>
          </div>
        </div>
        <div class="hd_main" v-if="!dataLoading && !emptyData">
          <div class="cl_tit_main">
            <div class="text" v-if="basicsObj">
              {{ basicsObj.ts_name }}
              <!-- <i class="sub_icon" @click="showIconText" v-if="basicsObj.isSub"></i> -->

              <span class="mock-status-run" v-if="basicsObj && basicsObj.open_status === 1"
                >进行中</span
              >
              <span class="mock-status-end" v-if="basicsObj && basicsObj.open_status === 0"
                >已关闭</span
              >
            </div>
            <img
              v-if="
                basicsObj &&
                basicsObj.open_status === 1 &&
                (basicsObj.isMn || compareVersions(versionInfo, 9.75))
              "
              :src="themeStyleVs === 2 ? blockDian : dianImg"
              @click="showPopup"
            />
            <div
              class="btn"
              v-if="
                basicsObj &&
                !basicsObj.isMn &&
                !basicsObj.isGz &&
                !compareVersions(versionInfo, 9.75)
              "
              @click="gzFn"
            >
              关注
            </div>
            <div
              class="btn ygzBtn"
              v-if="
                basicsObj &&
                !basicsObj.isMn &&
                basicsObj.isGz &&
                !compareVersions(versionInfo, 9.75)
              "
              @click="delGz"
            >
              已关注
            </div>
          </div>
          <!-- <div class="Trading_type">
            <div class="under_way" v-if="basicsObj && basicsObj.open_status === 1">
              <span class="jinx">进行中</span>
              <span class="zq_box" v-if="basicsObj.isMn === true"
                >持股周期：{{ basicsObj.ts_chigu }}天</span
              >
              <span class="dp_box" v-if="datailObj.tradeRule === 1"
                >大盘择时交易-{{ setTemplateName(datailObj.riskTemplate) }}</span
              >
            </div>
            <div class="close_box" v-if="basicsObj && basicsObj.open_status === 0">已关闭</div>
          </div> -->
          <div class="introduce_box" v-if="basicsObj">
            <div class="introduce_box_avatar" @click="gotoUserHome(basicsObj.uname)" >
              <img :src="basicsObj.headUrl" alt="" srcset="" />
            </div>
            <p @click="gotoUserHome(basicsObj.uname)" > {{ basicsObj.nickname }} </p>

            <span>创建于：{{ basicsObj.ct.substr(0, 10) }}</span>
            <span v-if="basicsObj && basicsObj.open_status === 0"
              >截止时间：{{ basicsObj.ut }}</span
            >
          </div>
          <!-- 描述 -->
          <div class="text-wrapper" v-if="basicsObj && basicsObj.ts_desc && basicsObj.ts_desc!== ''" >
            <div class="text-content" ref="textContent" :class="{ collapsed: !expanded }">
              {{ basicsObj ? basicsObj.ts_desc : '' }}
            </div>
            <span class="head-desc-but" v-if="showToggle" @click="toggle">
              {{ expanded ? '收起' : '展开' }}
            </span>
          </div>

          <div class="msg_main clearfix">
            <ul class="clearfix">
              <li>
                <p v-if="datailObj" :class="[judgeColor(datailObj.totalRisk)]">
                  {{
                    datailObj || datailObj.totalRisk == 0
                      ? toFixedNum(datailObj.totalRisk * 100, 2, '%')
                      : '--'
                  }}
                </p>
                <p>创建后收益</p>
              </li>
              <li>
                <p v-if="datailObj" :class="[judgeColor(datailObj.todayRisk)]">
                  {{
                    datailObj || datailObj.todayRisk == 0
                      ? toFixedNum(datailObj.todayRisk * 100, 2, '%')
                      : '--'
                  }}
                </p>
                <p>今日收益</p>
              </li>
              <li>
                <p v-if="datailObj" :class="[judgeColor(datailObj.yearProfit)]">
                  {{
                    datailObj || datailObj.yearProfit == 0
                      ? toFixedNum(datailObj.yearProfit * 100, 2, '%')
                      : '--'
                  }}
                </p>
                <p>最大年化收益</p>
              </li>
            </ul>
            <ul class="clearfix">
              <li>
                <p v-if="datailObj">
                  {{
                    datailObj || datailObj.maxRetreatRate === 0
                      ? toFixedNum(datailObj.maxRetreatRate * 100, 2, '%')
                      : '--'
                  }}
                </p>
                <p>当前最大回撤</p>
              </li>
              <li>
                <p v-if="datailObj">
                  {{
                    datailObj || datailObj.successRate == 0
                      ? toFixedNum(datailObj.successRate * 100, 2, '%')
                      : '--'
                  }}
                </p>
                <p>交易胜率</p>
              </li>
              <li>
                <p v-if="datailObj">
                  {{
                    datailObj || datailObj.sharpeRate == 0
                      ? toFixedNum(datailObj.sharpeRate, 2, '')
                      : '--'
                  }}
                </p>
                <p>夏普比率</p>
              </li>
            </ul>
          </div>
          <div class="msg_main divisor_main">
            <div class="yzc_list">
              <ul class="clearfix">
                <li>
                  <p>总资产</p>
                  <p v-if="datailObj">
                    {{
                      datailObj || datailObj.totalCapital == 0
                        ? '￥' + process(datailObj.totalCapital, 2, true, '')
                        : '--'
                    }}
                  </p>
                </li>
                <li>
                  <p>今日</p>
                  <p v-if="datailObj" :class="[judgeColor(datailObj.todayProfitLoss)]">
                    {{
                      datailObj || datailObj.todayProfitLoss == 0
                        ? '￥' + process(datailObj.todayProfitLoss, 2, true, '')
                        : '--'
                    }}
                  </p>
                </li>
                <li @click="hderShow">
                  <van-icon name="arrow-down" v-if="!headerDown" />
                  <van-icon name="arrow-up" v-else />
                </li>
              </ul>
              <ul class="clearfix" v-show="headerDown">
                <li>
                  <p>持仓市值</p>
                  <p v-if="datailObj">
                    {{
                      datailObj || datailObj.totalValue == 0
                        ? '￥' + process(datailObj.totalValue, 2, true, '')
                        : '--'
                    }}
                  </p>
                </li>
                <li>
                  <p>初始资金</p>
                  <p v-if="datailObj">
                    {{
                      datailObj || datailObj.startMoney == 0
                        ? '￥' + process(datailObj.startMoney, 2, true, '')
                        : '--'
                    }}
                  </p>
                </li>
                <li>
                  <p>仓位</p>
                  <p v-if="datailObj">
                    {{
                      datailObj || datailObj.cangWeiZhanBi == 0
                        ? toFixedNum(datailObj.cangWeiZhanBi * 100, 2, '%')
                        : '--'
                    }}
                  </p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </header>
    <div v-if="dataLoading">
      <van-loading size="24px" vertical style="margin-top: 45%">加载中...</van-loading>
    </div>
    <div
      :class="mainScrollShow ? 'contant_main scrollBox' : 'contant_main'"
      v-if="!dataLoading && !emptyData"
    >
      <div class="main_all">
        <ul class="nav_list_main" v-if="showModule">
          <li
            :class="navId === index ? 'active' : ''"
            v-for="(item, index) in navList"
            :key="index"
            @click="checkNav(index, item.id)"
          >
            {{ item.name }}
          </li>
        </ul>
        <!-- 策略分析 -->
        <div class="pj_main" id="clfx">
          <div class="tit_box">
            <p>策略分析</p>
          </div>
          <div class="xx_list">
            <ul>
              <li>
                <p v-if="clData" :class="[judgeColor(clData.profitRate)]">
                  {{ toFixedNum(clData.profitRate, 2, '%') }}
                </p>
                <p>累计收益</p>
              </li>
              <li>
                <p v-if="clData" :class="[judgeColor(clData.hs300Rate)]">
                  {{ toFixedNum(clData.hs300Rate, 2, '%') }}
                </p>
                <p>同期沪深300</p>
              </li>
              <li>
                <p v-if="clData" :class="[judgeColor(clData.regRate)]">
                  {{ toFixedNum(clData.regRate, 2, '%') }}
                </p>
                <p>参考拟合收益</p>
              </li>
            </ul>
          </div>
        </div>
        <p class="interval_box"></p>
        <!-- 收益分析 -->
        <div class="sy_main" id="syfx">
          <div class="tit_box">收益分析</div>
          <div class="cont_main">
            <div class="selice_main">
              <div class="left_btn_main">
                <van-checkbox v-model="checked" shape="square" @change="changeCheck"
                  >显示历史回测数据</van-checkbox
                >
              </div>
              <div class="right_selice">
                <div
                  :class="sySeliceShow ? 'selice_btn active' : 'selice_btn'"
                  @click="showSySelice"
                >
                  {{ radioTime | checkSelice }}
                </div>
                <div class="selice_box" v-show="sySeliceShow">
                  <ul v-if="checked">
                    <li
                      :class="radioTime === 'allData' ? 'active' : ''"
                      @click="changeTime('allData')"
                    >
                      全部
                    </li>
                    <li
                      :class="radioTime === 'sevenData' ? 'active' : ''"
                      @click="changeTime('sevenData')"
                    >
                      7天
                    </li>
                    <li
                      :class="radioTime === 'monthData' ? 'active' : ''"
                      @click="changeTime('monthData')"
                    >
                      近一个月
                    </li>
                  </ul>
                  <ul v-else>
                    <li
                      :class="radioTime === 'createData' ? 'active' : ''"
                      @click="changeTime('createData')"
                    >
                      全部
                    </li>
                    <li
                      :class="radioTime === 'seveCreateData' ? 'active' : ''"
                      @click="changeTime('seveCreateData')"
                    >
                      7天
                    </li>
                    <li
                      :class="radioTime === 'monthCreateData' ? 'active' : ''"
                      @click="changeTime('monthCreateData')"
                    >
                      近一个月
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="line_box" id="chartLine"></div>
            <div class="tab_cont_box">
              <span>累计收益</span>
              <span>沪深300</span>
              <span v-show="checked">拟合收益</span>
            </div>
          </div>
        </div>
        <p class="interval_box"></p>
        <!-- 计划交易 -->
        <div class="table_main" id="jhjy" v-if="showModule">
          <div class="tit_box">
            <div class="name_box">模拟计划交易</div>
            <div class="time_box">更新时间 {{ projectTime }}</div>
          </div>
          <div class="table_content" ref="watermarkBox">
            <table
              width="100%"
              cellspacing="0"
              cellpadding="0"
              v-if="jhjyQuery && projectData.length > 0"
            >
              <tr>
                <th>日期时间</th>
                <th>股票名称</th>
                <th>操作</th>
                <th>数量</th>
                <th>收盘价</th>
              </tr>

              <tr
                v-for="(item, index) in projectData"
                :key="index"
                @click="gotoFenShi(item.stockCode)"
              >
                <td>
                  <p>{{ convertTime(item.planTime) }}</p>
                  <p>{{ convertyr(item.planTime) }}</p>
                </td>
                <td>
                  <p>{{ item.stockName }}</p>
                  <p>{{ removePrefix(item.stockCode) }}</p>
                </td>
                <td>
                  <span :class="item.buySell | checkMmStyle">{{
                    item.buySell === 'B' ? '调入' : '调出'
                  }}</span>
                </td>
                <td>{{ item.amount }}</td>
                <td>{{ toFixedNum(item.newPrice) }}</td>
              </tr>
            </table>
            <van-empty v-else class="custom-image" :image="not_data" description="暂未获取到数据" />
            <div class="statement_box" v-if="!basicsObj.isMn">
              <span class="tit">免责声明：</span
              >本页面信息仅代表当前量化模型的模拟盘交易记录，数据均基于历史统计，不代表未来趋势，仅供参考，不构成投资建议，投资有风险，入市需谨慎，如有他人借此进行非法荐股行为请及时向有关部门举报。
            </div>
          </div>
        </div>
        <p class="interval_box" v-if="showModule"></p>
        <!-- 持仓详情 -->
        <div class="table_main ccxq" id="ccxq" v-if="showModule">
          <div class="tit_box">
            <div class="name_box">模拟持仓详情</div>
            <div class="time_box">更新时间 {{ takeTime }}</div>
          </div>
          <div class="table_content">
            <table
              width="100%"
              cellspacing="0"
              cellpadding="0"
              v-if="ccxqQuery && takeData.length > 0"
            >
              <tr>
                <th>买入日期</th>
                <th>股票名称</th>
                <th>数量/仓位</th>
                <th>现价/成本价</th>
                <th>浮动溢价</th>
              </tr>
              <tr
                v-for="(item, index) in takeData"
                :key="index"
                @click="gotoFenShi(item.stockCode)"
              >
                <td>
                  <p>{{ item.createTime }}</p>
                  <p>持有{{ item.posDayNum }}天</p>
                </td>
                <td>
                  <p>{{ item.stockName }}</p>
                  <p>{{ removePrefix(item.stockCode) }}</p>
                </td>
                <td>
                  <p>{{ toFixedNum(item.posAmount, 0, '') }}</p>
                  <p>{{ toFixedNum(item.cangweizhanbi * 100, 2, '%') }}</p>
                </td>
                <td>
                  <p>{{ toFixedNum(item.newPrice) }}</p>
                  <p>{{ toFixedNum(item.posPrice) }}</p>
                </td>
                <td>
                  <p :class="[judgeColor(item.profit)]">{{ toFixedNum(item.profit) }}</p>
                  <p :class="[judgeColor(item.profitRatio)]">
                    {{ toFixedNum(item.profitRatio * 100, 2, '%') }}
                  </p>
                </td>
              </tr>
            </table>
            <van-empty v-else class="custom-image" :image="not_data" description="暂未获取到数据" />
          </div>
        </div>
        <p class="interval_box" v-if="showModule"></p>
        <!-- 模拟调仓记录 -->
        <div class="table_main tcjl" id="tcjl" v-if="showModule">
          <div class="tit_box" id="titId">
            <div class="name_box">模拟调仓记录</div>
            <div class="time_box">更新时间 {{ warehouseTime }}</div>
          </div>
          <div class="nav_box scroll_nav_box" v-show="mainScrollShow && dcNavShow">
            <div :class="warehouseType === 0 ? 'active' : ''" @click="checkTime(0)">今日调仓</div>
            <div :class="warehouseType === 1 ? 'active' : ''" @click="checkTime(1)">历史调仓</div>
          </div>
          <div class="nav_box">
            <div
              v-show="!dcNavShow"
              :class="warehouseType === 0 ? 'active' : ''"
              @click="checkTime(0)"
            >
              今日调仓
            </div>
            <div
              v-show="!dcNavShow"
              :class="warehouseType === 1 ? 'active' : ''"
              @click="checkTime(1)"
            >
              历史调仓
            </div>
          </div>
          <div class="table_content">
            <table
              width="100%"
              cellspacing="0"
              cellpadding="0"
              v-if="warehouseQuery && warehouseData.length > 0"
            >
              <tr>
                <th>时间</th>
                <th>股票名称</th>
                <th>操作</th>
                <th>价格/数量</th>
                <th>平仓盈亏</th>
              </tr>
              <tr
                v-for="(item, index) in warehouseData"
                :key="index"
                @click="gotoFenShi(item.stockCode)"
              >
                <td>
                  <p v-show="warehouseType === 1">{{ item.dealTime.substr(0, 10) }}</p>
                  <p>{{ item.dealTime.substr(11) }}</p>
                </td>
                <td>
                  <p>{{ item.stockName }}</p>
                  <p>{{ removePrefix(item.stockCode) }}</p>
                </td>
                <td>
                  <p :class="item.buySell | checkColor">
                    {{ item.buySell === 'B' ? '调入' : '调出' }}
                  </p>
                  <p>{{ strStyle(item.style) }}</p>
                </td>
                <td>
                  <p>{{ toFixedNum(item.price) }}</p>
                  <p>{{ item.buySell === 'B' ? '+' : '-' }}{{ item.amount }}</p>
                </td>
                <td :class="[judgeColor(item.profit)]">
                  <p>{{ toFixedNum(item.profit) }}</p>
                  <p>
                    {{
                      toFixedNum(
                        (item.profit / (item.amount * item.price - item.profit)) * 100,
                        2,
                        '%'
                      )
                    }}
                  </p>
                </td>
              </tr>
            </table>
            <van-empty
              v-if="warehouseType === 1 && warehouseQuery && warehouseData.length <= 0"
              class="custom-image"
              :image="not_data"
              description="暂未获取到数据"
            />
            <van-empty
              v-if="warehouseType === 0 && warehouseQuery && warehouseData.length <= 0 && timesShow"
              class="custom-image"
              :image="not_data"
              description="已于{17:00}结算，今日调仓移动到历史调仓"
            />
            <van-empty
              v-if="
                warehouseType === 0 && warehouseQuery && warehouseData.length <= 0 && !timesShow
              "
              class="custom-image"
              :image="not_data"
              description="暂未获取到数据"
            />
          </div>
          <div class="more_btn" v-show="total > warehouseData.length" @click="more">查看更多</div>
        </div>
        <div class="blank_div"></div>
      </div>
      <!-- <van-empty v-else class="custom-image" :image="not_data" :description="description5" /> -->
    </div>
    <div v-if="!dataLoading && emptyData">
      <van-empty class="custom-image" :image="not_data" :description="description5" />
    </div>

    <!-- 按钮 : 自定义/实盘 -->
    <div class="btn_box" v-if="!dataLoading && !emptyData">
      <div
        v-if="
          basicsObj &&
          ((basicsObj.tag_type > 1 && basicsObj.tag_type < 5) || basicsObj.isMn == true)
        "
        class="btn_box_qs"
      >
        <van-button class="box_qs_item box_qs_item_zdy" @click="lhhcShow = true"
          >查看策略参数</van-button
        >
        <van-button class="box_qs_item box_qs_item_qs" @click="goRealUrl()">去实盘</van-button>
      </div>
      <div v-else>
        <van-button class="btn_zdy_box" @click="lhhcShow = true">查看策略参数</van-button>
      </div>
    </div>

    <van-popup v-model="popupShow" round position="bottom">
      <div class="popup_box">
        <ul class="controls_ul">
          <!-- 开启成交推送 -->
          <li
            v-if="basicsObj && basicsObj.open_status == 1 && compareVersions(versionInfo, 9.75)"
            @click="subInfo()"
          >
            {{ basicsObj.isSub == true ? '关闭成交信号推送（已开启）' : '开启成交信号推送' }}
          </li>
          <li v-if="basicsObj && basicsObj.isMn == false" @click="showGz">
            {{ basicsObj.isGz === false ? '关注' : '取消关注（已关注）' }}
          </li>
          <li v-if="basicsObj && basicsObj.isMn == true && getMobileOSType() !== 4" @click="showWx">
            {{ basicsObj.wechat_push === 0 ? '开启计划交易推送' : '关闭计划交易推送（已开启）' }}
          </li>
          <li
            v-if="basicsObj && basicsObj.isMn == true && getMobileOSType() !== 4"
            @click="openDialogConfirm(basicsObj.public_open !== 1 ? 1 : 0)"
          >
            {{ basicsObj.public_open !== 1 ? '公开策略' : '取消公开策略(已公开)' }}
          </li>
          <li
            v-if="basicsObj && basicsObj.isMn == true && basicsObj.review_status !== '1'"
            @click="closeMn"
          >
            {{ basicsObj.open_status === 1 ? '关闭模拟盘' : '模拟盘已关闭' }}
          </li>
          <li v-if="basicsObj && basicsObj.isMn == true" @click="goLink">去回测页面</li>
        </ul>
        <div class="close_box" @click="popupShow = false">取消</div>
      </div>
    </van-popup>
    <!-- 没有慧豆时页面显示 -->
    <!-- <NotHd v-if="notHd && detailDataQuery"></NotHd> -->

    <van-dialog
      v-model="coleMnShow"
      message="请您再次确认是否需要关闭模拟交易，模拟交易关闭后，将停止更新及推送，并无法再次开启。"
      :showCancelButton="true"
      className="dialog_box"
      confirmButtonText="关闭模拟盘"
      confirmButtonColor="#999999"
      cancelButtonText="取消"
      @confirm="coleMnShowInfo()"
      @close="coleMnShow = false"
    >
    </van-dialog>

    <!-- 弹窗 -->
    <van-overlay :show="showOverlay" style="z-index: 999">
      <div class="wrapper">
        <van-loading size="24px" color="#1989fa" vertical>加载中...</van-loading>
      </div>
    </van-overlay>

    <!-- 弹窗 -->
    <van-popup
      v-model="lhhcShow"
      closeable
      close-icon="close"
      round
      position="bottom"
      :style="{ height: 'auto' }"
      class="lhhc-info-popup"
    >
      <div class="lhhc-info">
        <!-- 因子池内容 -->
        <div class="lhhc-factor">
          <div class="lhhc-factor-title">· 因子池内容</div>
          <div class="lhhc-factor-name" v-if="basicsObj">[{{ basicsObj.ts_name }}]策略因子</div>
          <div class="lhhc-factor-list">{{ mockHcInfo.factorDesc }}</div>
        </div>
        <!-- 交易参数 -->
        <div class="lhhc-jycs">
          <LhHcjycs :mockHcInfo="mockHcInfo" :datailObj="basicsObj" />
        </div>
        <!-- 提交按钮 -->
        <div class="lhhc-jycs-btn" v-if="basicsObj && basicsObj.zdyType !== '1'"  @click.stop="setZdyConditionsFunc()" >
          <van-button class="lhhc-jycs-btn-style"
            >编辑策略参数成为我的策略</van-button
          >
          <!-- <van-button class="lhhc-jycs-btn-style" @click="copyZdyHcFunc()"
            >复制该策略并回测</van-button
          > -->
        </div>
      </div>
    </van-popup>

    <!-- 实盘的弹窗 realShow  -->
    <van-dialog
      v-model="realShow"
      class="real_box_dialog"
      :showCancelButton="false"
      :showConfirmButton="false"
    >
      <div class="real_box">
        <div class="real_box_title">
          进入量化实盘账户，从【导入策略】中同步<span style="color: #286df7">「示例策略」</span
          >后进行实盘交易
        </div>
        <div class="real_box_img">
          <img src="@/assets/image/mock/sp-dialog.png" alt="" srcset="" />
        </div>
        <div class="real_box_but">
          <div>
            <van-button
              class="real_box_but_res"
              icon="arrow"
              icon-position="right"
              @click="goRealOpenUrl(0)"
              v-if="basicsObj && basicsObj.tag_type !== 4"
            >
              还未签约，立即签约
            </van-button>
            <div class="real_box_but_text" @click="goRealOpenUrl(1)">进入实盘交易</div>
          </div>
        </div>
      </div>
    </van-dialog>
    <!-- 关闭按钮 -->
    <div class="real_box_close" v-show="realShow" @click="realShow = false">
      <img src="@/assets/image/sp-dilogclose.png" class="real_box_close_img" alt="" srcset="" />
    </div>
    <!-- 公开提醒的弹窗 -->
    <van-dialog
      v-model="openDialog"
      class="open_dialog"
      :showCancelButton="false"
      :showConfirmButton="false"
    >
      <div class="open_dialog_content">
        <div class="open_dialog_top">
          <img src="@/assets/image/mock/mn-open-top-black.png" alt="" srcset="" v-if="themeStyleVs === 2" />
          <img src="@/assets/image/mock/mn-open-top.png" alt="" srcset="" v-else />
        </div>
        <div class="open_dialog_bottom">
          <div class="open_dialog_bottom_title">是否将该策略公开？</div>
          <div class="open_dialog_bottom_desc">公开后您的策略将有可能出现在策略首页</div>
          <div class="open_dialog_bottom_btn_box">
            <van-button
              class="open_dialog_bottom_btn open_dialog_bottom_btn_cancel"
              @click="openDialog = false"
              >取消</van-button
            >
            <van-button
              class="open_dialog_bottom_btn open_dialog_bottom_btn_confirm"
              @click="openDialogConfirm(1)"
              >确定</van-button
            >
          </div>
        </div>
      </div>
    </van-dialog>

    <!-- 我的实盘弹窗 -->
    <van-dialog
      v-model="realMeShow"
      class="real_me_box_info"
      :showCancelButton="false"
      :showConfirmButton="false"
    >
      <div class="box_info">
        <div class="box_info_top">
          <div class="box_info_top_icon"></div>
          <div class="box_info_top_text">选择券商</div>
          <div class="box_info_top_icon">
            <van-icon name="cross" size="20px" color="#9199A5" @click="realMeShow = false">
            </van-icon>
          </div>
        </div>
        <div class="box_info_list">
          <div
            class="box_info_item"
            v-for="(valueqs, keyqs) in realMeList"
            :key="keyqs"
            :class="{ box_info_item_active: keyqs == realMeActive }"
            @click="realMeActive = keyqs"
          >
            <div class="box_info_item_qs">
              <div class="box_info_item_qs_name">
                <div class="box_info_item_qs_name_icon">
                  <img src="@/assets/image/qs/xc.png" alt="" srcset="" v-if="keyqs == 0" />
                  <img src="@/assets/image/qs/fz.png" alt="" srcset="" v-if="keyqs == 1" />
                  <img src="@/assets/image/qs/hx.png" alt="" srcset="" v-if="keyqs == 2" />
                </div>
                <div class="box_info_item_qs_name_text">{{ valueqs.name }}</div>
              </div>
              <div
                class="box_info_item_qs_desc"
                v-if="keyqs == realMeActive"
                @click="goRealMeOpenUrl(valueqs.open, valueqs.name) "
              >
                还未开户？去开户签约
              </div>
              <div class="box_info_item_qs_desc" v-else>还未开户？去开户签约</div>
            </div>
            <div class="box_info_item_icon">
              <img
                src="@/assets/image/qs/select.png"
                alt=""
                srcset=""
                v-if="keyqs == realMeActive"
              />
              <img src="@/assets/image/qs/ont-select.png" alt="" srcset="" v-else />
            </div>
          </div>
        </div>
        <div class="box_info_btn" @click="goRealMeUrl(realMeActive)">去实盘</div>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import navigation from '@/components/navigation.vue';
import NotHd from '@/components/notHd/notHd.vue';

import LhHcjycs from '@/components/details/LhHcjycs.vue';
import { initiateLhHc } from '@/api/create.js';

import mixin from '@/mixins/index.js';
import {
  toFixedNum,
  judgeColor,
  formtTime,
  fangDouFun,
  getArrayIndex,
  compareVersions
} from '@/utils/format';
import {
  getMokpanelDetails,
  getMokpanelDetailsQuery,
  getMokpanelTradingplan,
  getMokpanelHold,
  getMokpanelDeal,
  openWechat,
  mockpanelClose,
  reportBrowse,
  addMyFavor,
  delMyFavor,
  setShareById
} from '@/api/index.js';

import { getMockByHcInfo, updatePublicOpen } from '@/api/mock.js';
import { mapMutations } from 'vuex';

import { addSubApi, delSubApi } from '@/api/my.js';
import VueScrollTo from 'vue-scrollto';
var Base64 = require('js-base64').Base64;
export default {
  name: 'tacticsdetail',
  mixins: [mixin],
  components: {
    navigation,
    NotHd,
    LhHcjycs
  },
  data() {
    return {
      description5: '数据加载中',
      blockDian: require('../../assets/image/blockImg/dian_img.png'),
      dianImg: require('../../assets/image/dian.png'),
      not_data: require('../../assets/image/notData.png'),
      typely: '', //来源
      zj_id: '',
      expanded: false,
      showToggle: true,
      headerDown: false, // 头部下箭头显示隐藏；
      basicsObj: null, // 模拟交易 基本信息
      datailObj: null, // 详细信息
      checked: true, // 是否显示历史回测数据
      clData: null, //策略分析数据
      radioTime: 'allData', //图表数据显示类型
      lineData: null, //图表数据
      sySeliceShow: false, // 选择框显示隐藏
      projectData: [], //计划交易列表数据
      projectTime: '', //计划交易更新时间

      filterNum: 0,
      scrollTop: 300,
      mainScrollShow: false,
      navList: [
        { name: '策略分析', id: 'clfx' },
        { name: '模拟计划交易', id: 'jhjy' },
        { name: '模拟持仓详情', id: 'ccxq' },
        { name: '模拟调仓记录', id: 'tcjl' }
      ],
      navId: 0,
      lineChart: null,

      takeData: [], //持仓详情数据
      takeTime: '', // 持仓详情时间
      hotTacticInterval: null, // 定时器
      warehouseData: [], //调仓数据
      warehouseTime: '', //调仓时间
      warehouseType: 0, //调仓数据类型
      warehousePage: 1,
      warehouseSize: 20,
      total: 0,

      dcNavShow: false,

      popupShow: false,
      // 一下为空状态判断
      warehouseQuery: false, //模拟调仓记录
      jhjyQuery: false, //计划交易
      ccxqQuery: false, //持仓详情
      notHd: true, //没有慧豆
      detailDataQuery: false,
      timesShow: false,
      themeStyleVs: 1,
      // 关闭模拟交易
      coleMnShow: false,
      // 版本号
      versionInfo: 9.73,
      // 遮罩弹窗
      showOverlay: false,
      // 量化信息弹窗
      lhhcShow: false,
      // 回测信息
      mockHcInfo: {},
      // 展示模块权限 : true-展示  false-不展示
      showModule: false,
      // 用户是否是VIP : true-是  false-否
      isVip: false,
      // 实盘的弹窗
      realShow: false,
      // 找到的券商信息
      targetQs: {},
      // 标识来源
      mark: this.$route.query.mark || '',
      // 公开弹窗
      openDialog: false,
      // 我的实盘
      realMeShow: false,
      realMeList: [],
      realMeActive: 0,
      // 空数据状态以及加载状态
      emptyData: false,
      dataLoading: false
    };
  },
  filters: {
    checkSelice: function (id) {
      switch (id) {
        case 'allData':
          return '全部';
          break;
        case 'sevenData':
          return '7天';
          break;
        case 'monthData':
          return '近一个月';
          break;
        case 'createData':
          return '全部';
          break;
        case 'seveCreateData':
          return '7天';
          break;
        case 'monthCreateData':
          return '近一个月';
          break;
      }
    },
    checkMmStyle: function (id) {
      if (id === 'B') {
        return 'business';
      } else {
        return 'businesssell';
      }
    },
    checkColor: function (id) {
      if (id === 'B') {
        return 'red';
      } else {
        return 'green';
      }
    }
  },
  watch: {
    '$store.state.isVip': {
      handler(newValue) {
        this.isVip = newValue;
      },
      immediate: true // 立即执行一次
    }
  },
  created() {
    this.dataLoading = true;
    this.themeStyleVs = Number(this.getUrlQuery('themeStyleVs'));
    this.versionInfo = this.getUrlQuery('version');
    let u = navigator.userAgent;
    if (
      typeof DzhAppJs !== 'undefined' &&
      u.indexOf('iPhone') > -1 &&
      !compareVersions(this.getUrlQuery('version'), 9.65)
    ) {
      let obj = { navBarHidden: 1, titleHidden: 1 };
      DzhAppJs.callAppWithChannelAndJsonAndCallbackFunc('setTitleStyle', JSON.stringify(obj), '');
    }
    this.zj_id = this.getUrlQuery('zj_id');
    this.typely = this.getUrlQuery('type') ? this.getUrlQuery('type') : '';
    this.getDetailData();
    let newDate = this.formtTime(new Date(), 'hh:mm').replace(':', '');
    this.timesShow = newDate > '1700';
  },
  mounted() {
    this.realMeList = window.realMeQslist;
    this.resetState(); //重置部分vuex
  },
  methods: {

    toFixedNum,
    judgeColor,
    formtTime,
    compareVersions,
    ...mapMutations(['resetState']),

    toggle: function () {
      this.expanded = !this.expanded;
    },

   // 检测文字是否超过2行
checkTextOverflow: function() {
  if (this.$refs.textContent && this.basicsObj && this.basicsObj.ts_desc) {
    const element = this.$refs.textContent;

    // 创建一个临时的测量元素
    const measureElement = document.createElement('div');
    measureElement.style.cssText = `
      position: absolute;
      visibility: hidden;
      width: ${element.offsetWidth}px;
      font-size: ${window.getComputedStyle(element).fontSize};
      font-family: ${window.getComputedStyle(element).fontFamily};
      line-height: ${window.getComputedStyle(element).lineHeight};
      word-wrap: break-word;
      word-break: break-all;
    `;
    measureElement.textContent = this.basicsObj.ts_desc;

    // 添加到DOM中测量完整高度
    document.body.appendChild(measureElement);
    const fullHeight = measureElement.offsetHeight;

    // 计算单行高度
    measureElement.textContent = '测试';
    const singleLineHeight = measureElement.offsetHeight;

    // 移除测量元素
    document.body.removeChild(measureElement);

    // 计算2行的高度
    const twoLineHeight = singleLineHeight * 2;

    // console.log('fullHeight:', fullHeight, 'twoLineHeight:', twoLineHeight, 'singleLineHeight:', singleLineHeight);

    // 判断是否需要显示展开按钮
    this.showToggle = fullHeight > twoLineHeight + 5; // 加5px容错

    // 如果文字不超过2行，移除collapsed类
    if (!this.showToggle) {
      element.classList.remove('collapsed');
    }
  }
},

    // 头部信息点击显示隐藏
    hderShow: function () {
      this.headerDown = !this.headerDown;
    },
    getMobileOSType: function () {
      const ua = navigator.userAgent || navigator.vendor || window.opera;

      const isIOS = /iPhone|iPad|iPod/i.test(ua);
      const isAndroid = /Android/i.test(ua);
      const isHarmony = /dzhhmtablet ohos|ohos|dzhapp ohos|dzhhm2in1 ohos/i.test(ua);

      if (isHarmony) return 4; // 移动鸿蒙终端
      if (isIOS) return 2; // 移动 iOS 终端
      if (isAndroid) return 3; // 移动 Android 终端

      return 1; // pc
    },
    // 请求模拟交易详情 -- 基本信息
    getDetailData: function () {
      let that = this;
      let obj = {
        zj_id: that.zj_id,
        type: that.typely
      };
      getMokpanelDetails(obj).then((res) => {
        // 关闭加载框
        that.dataLoading = false;
        if (res.err === 200) {
          // 关闭空数据状态
          that.emptyData = false;

          that.basicsObj = res.data;
          if (!res.data.isMn) {
            that.upReport(res.data.zj_id);
          } else {
            // 弹出一下是否公开的弹窗
            if (res.data.public_open !== 1 && that.mark == 'clgc') {
              that.openDialog = true;
            }
          }
          this.$nextTick(function () {
            // 获取回测数据
            this.getMockByHcInfoFunc(res.data.h_id);
            this.getEarnings();

            // 判断条件 : 是否是自己 , 是否拥有权限 , 是否是券商策略

            // 1. 判断是否是自己
            let showModule = false;
            if (res.data.isMn === true) {
              showModule = true;
            }

            // 2. 判断是否是VIP
            if (that.isVip === true) {
              showModule = true;
            }

            // 3. 判断类型区间
            if (!(res.data.tag_type < 5)) {
              showModule = true;
            }

            that.showModule = showModule;
            // 当展示的时候才请求 计划交易,持仓详情,调仓记录
            if (showModule) {
              this.getproject();
              this.getTake();
              this.getWarehouseData(true);
              window.addEventListener('scroll', this.allPageScroll, true);
            }
          });
        }

        if (res.err == 304) {
          that.notHd = true;
          window.location.href = window.config.hdTips;
        } else {
          that.notHd = false;
        }
        if (res.err === 305) {
          that.$toast('功能使用异常，请检查您的登录状态');
        }
        // 无权限查看
        if (res.err == 306) {
          // that.notHd = true;
          var url = window.config.buyTips + '&infoId=' + res.data;

          location.href = 'dzh_browser_url&goto=0&screen=263&nextUrl=' + btoa(url);
        }

        // 空数据
        if (res.err == 301) {
          that.emptyData = true;
          that.description5 = '数据加载为空';
        }

        that.$nextTick(function () {
          that.detailDataQuery = true;
          // 检测文字是否超过2行
          that.$nextTick(() => {
            that.checkTextOverflow();
          });
        });
      });
    },

    // 模拟交易详情 - 获取回测信息
    getMockByHcInfoFunc: function (hid) {
      console.log('hid', hid);
      let _this = this;
      let params = {
        h_id: hid
      };
      getMockByHcInfo(params)
        .then((result) => {
          if (result.err == 200) {
            _this.mockHcInfo = result.data;
          } else {
            _this.mockHcInfo = {};
          }
        })
        .catch((err) => {
          _this.mockHcInfo = {};
        });
    },

    // 模拟交易详情 -- 收益详情 以及 分析
    getEarnings: function () {
      let that = this;
      let obj = {
        zj_id: that.zj_id
      };
      that.description5 = '数据加载中';
      getMokpanelDetailsQuery(obj)
        .then((res) => {
          if (res.err === 200) {
            that.datailObj = res.data.details;
            that.clData = res.data.income.overall;
            that.lineData = res.data.lineData;
            that.$nextTick(function () {
              that.changeCheck(true);
            });
          } else {
            that.description5 = '暂未获取到数据';
          }
        })
        .catch(() => {
          that.description5 = '暂未获取到数据';
        });
    },
    // 上报数据
    upReport: function (id) {
      let obj = {
        id: id,
        type: 3
      };
      reportBrowse(obj).then((res) => {});
    },
    // change修改复选框状态
    changeCheck: function (i) {
      if (i) {
        if (this.radioTime === 'createData') this.radioTime = 'allData';
        if (this.radioTime === 'seveCreateData') this.radioTime = 'sevenData';
        if (this.radioTime === 'monthCreateData') this.radioTime = 'monthData';
      } else {
        if (this.radioTime === 'allData') this.radioTime = 'createData';
        if (this.radioTime === 'sevenData') this.radioTime = 'seveCreateData';
        if (this.radioTime === 'monthData') this.radioTime = 'monthCreateData';
      }
      if (this.lineChart) {
        this.lineChart.dispose();
        this.lineChart = null;
      }
      this.getLineEcharts();
    },
    // 修改选择框
    changeTime: function (id) {
      this.radioTime = id;
      if (this.lineChart) {
        this.lineChart.dispose();
        this.lineChart = null;
      }
      this.getLineEcharts();
      this.sySeliceShow = false;
    },

    showSySelice: function () {
      this.sySeliceShow = !this.sySeliceShow;
    },
    // 页面图表数据
    getLineEcharts: function () {
      let that = this;
      let arr = [],
        regRateArr = [];
      let { lineData, radioTime } = this;
      for (let i = 0; i < lineData[radioTime].regRate.length; i++) {
        if (i === lineData[radioTime].regRate.length - 1) {
          arr.push(lineData[radioTime].regRate[lineData[radioTime].regRate.length - 1]);
        } else {
          arr.push(null);
        }
      }
      regRateArr = this.smoothArray(
        arr,
        0,
        lineData[radioTime].regRate[lineData[radioTime].regRate.length - 1]
      );
      if (!that.lineChart) {
        that.lineChart = this.$echarts.init(document.getElementById('chartLine'));
        window.addEventListener('resize', that.resizeHandler);
      }
      let option;
      option = {
        color: ['#286DF7', '#FF9153'],
        tooltip: {
          trigger: 'axis',
          confine: true,
          extraCssText: 'z-index:2',
          backgroundColor: that.$route.query.themeStyleVs == 2 ? '#181A23' : '#fff',
          borderColor: that.$route.query.themeStyleVs == 2 ? '#181A23' : '#fff', // 设置 Tooltip 的边框颜色
          textStyle: {
            // 设置 Tooltip 中文字的样式
            color: that.$route.query.themeStyleVs == 2 ? '#AAB9D1' : '' // 设置文字颜色
          },
          formatter: function (param) {
            var result = `<p style="margin-bottom: 10px;">${param[0].name}</p>`;
            param.forEach((el, index) => {
              if (el.seriesName === '拟合收益') {
                result += `
    		              <p style="margin-bottom: 10px;">${el.marker}${el.seriesName}: ${
                  lineData[radioTime].regRate[
                    getArrayIndex(lineData[radioTime].xData, param[0].name)
                  ]
                }% </p>`;
              } else {
                result += `
    		              <p style="margin-bottom: 10px;">${el.marker}${el.seriesName}: ${el.value}% </p>`;
              }
            });
            return result;
          }
        },
        grid: {
          left: 0,
          right: 3,
          bottom: 10,
          top: 10,
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            data: lineData[radioTime].xData,
            axisLine: { onZero: true, show: false },
            axisTick: { show: false },
            axisLabel: {
              color: that.themeStyleVs === 2 ? '#6B7687' : '#999',
              show: true,
              interval: 10000,
              showMinLabel: true,
              showMaxLabel: true,
              formatter: function (value) {
                //文本格式化
                if (value === lineData[radioTime].xData[0]) {
                  return '{right|' + value + '}';
                } else if (
                  value === lineData[radioTime].xData[lineData[radioTime].xData.length - 1]
                ) {
                  return '{left|' + value + '}';
                } else {
                  return '{center|' + value + '}';
                }
              },
              rich: {
                right: {
                  width: 50,
                  fontSize: 10,
                  align: 'left',
                  padding: [0, 0, 0, 50]
                },
                left: {
                  width: 50,
                  fontSize: 10,
                  align: 'left',
                  padding: [0, 50, 0, 0]
                },
                center: {
                  fontSize: 10,
                  align: 'left'
                }
              }
            }
          }
        ],
        yAxis: {
          type: 'value',
          position: 'left',
          axisTick: { show: false },
          axisLine: {
            show: false
          },
          axisLabel: {
            color: that.themeStyleVs === 2 ? '#6B7687' : '#999',
            show: true,
            formatter: function (val) {
              return val + '%';
            }
          },
          splitLine: {
            show: true,
            lineStyle: {
              type: 'solid',
              color: that.themeStyleVs === 2 ? '#6B7687' : '#e5e5e5'
            }
          }
        },
        series: [
          {
            data: lineData[radioTime].profitRate,
            type: 'line',
            name: '累计收益',
            symbol: 'none',
            smooth: true,
            areaStyle: {
              // color:['rgba(40, 109, 247, 0.2)','rgba(40, 109, 247, 0)']
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: 'rgba(58,132,255, 0.5)' // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: 'rgba(58,132,255, 0)' // 100% 处的颜色
                  }
                ],
                global: false // 缺省为 false
              }
            }
          },
          {
            data: lineData[radioTime].hs300Rate,
            type: 'line',
            name: '沪深300',
            symbol: 'none',
            smooth: true,
            areaStyle: {
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: 'rgba(247, 152, 40, 0.5)' // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: 'rgba(247, 152, 40, 0)' // 100% 处的颜色
                  }
                ],
                global: false // 缺省为 false
              }
            }
          },
          {
            connectNulls: true,
            data: this.checked && radioTime === 'allData' ? regRateArr : [],
            type: 'line',
            name: '拟合收益',
            smooth: true,
            showSymbol: false,

            itemStyle: {
              // 折线和小圆点的颜色
              color: '#C7CBD5'
            },
            lineStyle: {
              // 折线的样式
              color: '#C7CBD5',
              type: 'dashed',
              width: 1
            }
          }
        ]
      };

      option && that.lineChart.setOption(option);
    },
    resizeHandler() {
      if (this.lineChart) {
        this.lineChart.resize();
      }
    },

    smoothArray: function (arr, startNum, endNum = 0) {
      const arrLength = arr.length;
      const smoothStep = (endNum - startNum) / (arrLength - 1);
      let currentValue = startNum !== 0 ? startNum : 0 - smoothStep;

      return arr.map((item) => {
        if (item === null) {
          currentValue += smoothStep;
          return currentValue.toFixed(2);
        }
        return item;
      });
    },
    // 请求计划交易数据
    getproject: function () {
      let that = this;
      let obj = {
        zj_id: that.zj_id
      };
      that.jhjyQuery = false;
      getMokpanelTradingplan(obj).then((res) => {
        if (res.err === 200) {
          that.projectData = res.data.list;
          that.projectTime = res.data.latestTime;
          that.jhjyQuery = true;
          if (!that.basicsObj.isMn && res.data.list.length > 0) {
            that.$nextTick(function () {
              setTimeout(function () {
                let color =
                  that.themeStyleVs === 2 ? 'rgba(59, 133, 254, 0.20)' : 'rgba(40, 109, 247, .1)';
                that.$watermark.set(window.config.watermarkText, that.$refs.watermarkBox, color);
              }, 200);
            });
          }
        }
      });
    },
    // 持仓详情
    getTake: function () {
      let that = this;
      let obj = {
        zj_id: that.zj_id
      };
      that.ccxqQuery = false;
      getMokpanelHold(obj).then((res) => {
        if (res.err === 200) {
          that.takeData = res.data.list;
          that.takeTime = res.data.latestTime;
          that.ccxqQuery = true;
        }
      });
    },
    //  模拟交易详情 -- 今日调仓 or 历史调仓
    getWarehouseData: function (dataType) {
      let that = this;
      let obj = {
        zj_id: that.zj_id,
        type: that.warehouseType,
        buySell: 'all',
        page: that.warehousePage,
        size: that.warehouseSize
      };
      // that.warehouseQuery = false;
      getMokpanelDeal(obj).then((res) => {
        if (res.err === 200) {
          if (dataType) {
            that.warehouseData = res.data.list;
          } else {
            that.warehouseData = [...that.warehouseData, ...res.data.list];
          }
          that.warehouseTime = res.data.latestTime;
          that.total = res.data.total;
          that.warehouseQuery = true;
          that.$nextTick(function () {
            // 这里会形成一个报错(TODO:小陶)
            // that.allPageScroll();
          });
        }
      });
    },
    // 点击切换
    checkNavFn: fangDouFun(
      function (...args) {
        this.checkTime(...args);
      },
      200,
      true
    ),
    checkTime: function (id) {
      this.warehouseType = id;
      this.warehousePage = 1;
      // this.warehouseData = [];
      this.getWarehouseData(true);
    },
    // 点击下一页
    more: function () {
      this.warehousePage = this.warehousePage + 1;
      this.$nextTick(function () {
        this.getWarehouseData(false);
      });
      this.allPageScroll();
    },
    scrollToSection(sectionId) {
      let offsetHeight =
        document.querySelector('.navg_box').offsetHeight +
        document.querySelector('.nav_list_main').offsetHeight;
      VueScrollTo.scrollTo(`#${sectionId}`, 100, {
        offset: -offsetHeight // 调整偏移量以适应您的布局
      });
      // this.allPageScroll();
    },
    checkNav: function (id, type) {
      this.navId = id;
      this.scrollToSection(type);
    },
    //全屏滚动
    allPageScroll: function () {
      let that = this;
      var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      let clfx = document.querySelector('#clfx').offsetTop;
      let jhjy = document.querySelector('#jhjy').offsetTop;
      let ccxq = document.querySelector('#ccxq').offsetTop;
      let tcjl = document.querySelector('#tcjl').offsetTop;
      let navHeight = document.querySelector('.nav_list_main').offsetHeight;
      let topHeight = document.querySelector('#hdMain').offsetHeight;
      let navgBoxH = document.querySelector('.navg_box').offsetHeight;
      let contantMainTop = document.querySelector('.contant_main').offsetTop;
      let tcNavHeight = document.querySelector('.scroll_nav_box').offsetHeight;
      let titId = document.querySelector('#titId').offsetHeight;

      this.filterNum = (scrollTop / (contantMainTop / 6)).toFixed(2);
      if (scrollTop >= topHeight - navgBoxH) {
        that.mainScrollShow = true;
      } else {
        that.mainScrollShow = false;
      }
      if (scrollTop < clfx - navHeight) {
        that.navId = 0;
      } else if (
        scrollTop >= jhjy - navHeight - navgBoxH &&
        scrollTop < ccxq - navHeight - navgBoxH
      ) {
        that.navId = 1;
      } else if (
        scrollTop >= ccxq - navHeight - navgBoxH &&
        scrollTop < tcjl - navHeight - navgBoxH
      ) {
        that.navId = 2;
      } else if (scrollTop >= tcjl - navHeight - navgBoxH) {
        that.navId = 3;
        if (scrollTop >= tcjl - titId - navHeight) {
          that.dcNavShow = true;
        } else {
          that.dcNavShow = false;
        }
      }
    },
    // 点击显示弹出框
    showPopup: function () {
      this.popupShow = !this.popupShow;
    },
    // 开启微信推送
    showWx: function () {
      let that = this;
      if (that.basicsObj.wechat_push === 0) {
        let obj = {
          zj_id: that.zj_id
        };
        openWechat(obj).then((res) => {
          if (res.err === 200) {
            that.$set(that.basicsObj, 'wechat_push', 1);
            that.popupShow = false;
            that.$toast(res.msg);
          } else {
            that.$toast(res.msg);
          }
          if (res.err == 304) {
            window.location.href = window.config.hdTips;
          }
        });
      }
    },
    // 关闭模拟盘
    closeMn: function () {
      // 跳出弹窗
      this.coleMnShow = true;
    },
    coleMnShowInfo: function () {
      let that = this;
      if (that.basicsObj.open_status === 1) {
        let obj = {
          h_id: that.basicsObj.h_id
        };
        mockpanelClose(obj).then((res) => {
          if (res.err === 200) {
            that.$set(that.basicsObj, 'open_status', 0);
            that.popupShow = false;
            this.coleMnShow = false;
          } else {
            that.$toast(res.msg);
          }
        });
      }
    },
    // 跳转回测页
    goLink: function () {
      this.$router.push({
        path: '/lhhc-details',
        name: 'Lhhc-details',
        query: {
          source: 'lhcl', //用来标注是从多因子还是量化过去的
          token: this.$route.query.token || '',
          h_id: this.basicsObj.h_id,
          themeStyleVs: this.themeStyleVs,
          version: this.getUrlQuery('version')
        }
      });
    },
    // 判断是否是关注
    showGz: function () {
      let that = this;
      if (that.basicsObj.isGz) {
        this.delGz();
      } else {
        this.gzFn();
      }
    },
    // 关注
    gzFn: function () {
      let that = this;
      let obj = {
        type: 3,
        id: that.basicsObj.zj_id,
        s_name: that.basicsObj.ts_name,
        f_id_arr: that.basicsObj.h_id,
        creator: that.basicsObj.uname,
        counter_num: that.basicsObj.counter_num
      };
      addMyFavor(obj).then((res) => {
        if (res.err === 200) {
          that.basicsObj.isGz = true;
          that.$toast('关注成功');
        }
      });
    },
    // 取消关注
    delGz: function () {
      let that = this;
      let obj = {
        type: 3,
        id: that.basicsObj.zj_id
      };
      delMyFavor(obj).then((res) => {
        if (res.err === 200) {
          that.basicsObj.isGz = false;
          that.basicsObj.isSub = false;
          that.$toast('取消成功');
        }
      });
    },

    shareBtn: function () {
      let that = this;
      setShareById({}).then((res) => {
        if (res.err === 200) {
          let obj = {
            id: that.zj_id,
            type: 5,
            sid: res.data
          };
          let urlLink = encodeURIComponent(
            window.config.shareLink + '?DZHSPECIAL=256&sid=' + res.data + '&type=5&id=' + that.zj_id
          );
          if (/android/i.test(navigator.userAgent)) {
            urlLink = encodeURIComponent(urlLink);
          }
          window.location.href =
            'dzh_browser_url&goto=0&screen=470&title=我在大智慧因子投研平台发现了一个模拟交易，一起来看看吧！&text=因子投研平台&url=' +
            urlLink +
            '&icon=' +
            window.config.shareLogo +
            '&ext=' +
            JSON.stringify(obj);
        }
      });
    },
    // 跳转到新的分时(BS点)
    gotoFenShi: function (stock) {
      if (compareVersions(this.$route.query.version, 9.71)) {
        let obj = { name: this.basicsObj.ts_name, capitalId: this.zj_id };
        obj = JSON.stringify(obj);
        let baes64Obj = Base64.encode(obj);
        baes64Obj = baes64Obj.replace(/\*/g, '+').replace(/-/g, '/').replace(/\./g, '=');
        this.gotoNewsFenShi(stock, baes64Obj, 1);
      } else {
        this.gogufs(stock);
      }
    },
    // 模版名称
    setTemplateName: function (num) {
      num = num + '';
      switch (num) {
        case '0':
          return 'MACD仓控模板';
          break;
        case '1':
          return '均线模板';
          break;
        case '2':
          return '成交额仓控模板';
          break;
        case '3':
          return '乖离仓控模板';
          break;
        case '4':
          return '价格仓控模板';
          break;
        case '5':
          return '价格均线仓控模板';
          break;
        default:
          return '';
          break;
      }
    },
    // 是否开启模拟推送(成交信号)
    subInfo: function () {
      let that = this;
      if (that.showOverlay) {
        return false;
      }
      that.showOverlay = true;

      if (that.basicsObj.isSub == true) {
        // 取消订阅
        let params = {
          zj_id: that.basicsObj.zj_id
        };
        delSubApi(params)
          .then((result) => {
            if (result.err == 200) {
              that.basicsObj.isSub = false;
              that.showOverlay = false;
              that.$toast(result.msg);
            } else {
              that.showOverlay = false;
              that.$toast(result.msg);
            }
          })
          .catch((err) => {
            that.showOverlay = false;
            that.$toast('取消订阅失败,请稍后再试!');
          });
      } else {
        // 添加订阅
        let params = {
          zj_id: that.basicsObj.zj_id,
          ts_name: that.basicsObj.ts_name,
          counter_num: that.basicsObj.counter_num
        };
        addSubApi(params)
          .then((res) => {
            if (res.err == 200) {
              that.basicsObj.isSub = true;
              // 如果不是自己的 , 且未关注  把关注按钮点亮
              if (that.basicsObj.isMn == false && that.basicsObj.isGz == false) {
                that.basicsObj.isGz = true;
              }
              that.showOverlay = false;
              that.$toast(res.msg);
              // 判断是否是客户端版本 并且执行 updateFactorMNSubscribeState
              if (compareVersions(this.$route.query.version, 9.75)) {
                DzhAppJs.callAppWithChannelAndJsonAndCallbackFunc(
                  'updateFactorMNSubscribeState',
                  '',
                  ''
                );
              }
            } else {
              that.showOverlay = false;
              that.$toast(res.msg);
            }
          })
          .catch((err) => {
            that.showOverlay = false;
            that.$toast('订阅失败,请稍后再试!');
          });
      }
    },
    // 弹出文字效果
    showIconText: function () {
      let that = this;
      that.$toast('成交信号推送已开启');
    },
    // 点击自定义参数并回测按钮
    setZdyConditionsFunc: function () {
      var _this = this;
      // 判断是否是VIP
      if (_this.isVip) {
        this.setZdyBuyAndSelFunc();
        this.serVuexObjData();

         // 发起回测
        _this.initiateLhHcFunc(0);


      } else {
        // 弹窗 :
        let appJson = {
          DialogType: 'pro'
        };
        DzhAppJs.callAppWithChannelAndJsonAndCallbackFunc(
          'factorTYPerDialog',
          JSON.stringify(appJson),
          ''
        );
      }
    },
    // 复制自定义策略并回测
    copyZdyHcFunc: function () {
      var _this = this;
      // 判断是否是VIP
      if (_this.isVip) {
        _this.setZdyBuyAndSelFunc();
        // 发起回测
        _this.initiateLhHcFunc(1);
      } else {
        // 弹窗 :
        let appJson = {
          DialogType: 'pro'
        };
        DzhAppJs.callAppWithChannelAndJsonAndCallbackFunc(
          'factorTYPerDialog',
          JSON.stringify(appJson),
          ''
        );
      }
    },

    // 发起回测
    initiateLhHcFunc: function (value) {
      var _this = this;
      var params = _this.mockHcInfo;
      params.factorList = _this.mockHcInfo.f_id_arr;
      params.holdPeriodList = _this.mockHcInfo.chigu_cycle;
      params.startDate = _this.mockHcInfo.starDate;
      params.PositionLimit = _this.mockHcInfo.posLimit;
      initiateLhHc(params)
        .then((result) => {

          if (result.err == 200) {
            if(value == 1) {
              params.apiData = result.data;
              params.isEdit = false;
              _this.$store.commit('setObj', params);
              const query = {
                token: _this.$route.query.token || '',
                HashID: result.data.HashID,
                source: 'lhcl',
                mySource: '', //用来标注是从个人中心过去的
                themeStyleVs: _this.$route.query.themeStyleVs || 0,
                version: _this.$route.query.version || '',
                yzType: 'A',
                zxgType: 0,
                zdyType: 1
              };

              _this.$router.push({
                path: '/mock-preview',
                name: 'mock-preview',
                query: query
              });
            } else {
              const query = {
                token: this.$route.query.token || '',
                type: 'add',
                source: 'lhcl',
                themeStyleVs: this.$route.query.themeStyleVs || 0,
                version: this.$route.query.version || '',
                yzType: 'A',
                zdyType: 1,
                zdySource: 1
              };

              this.$router.push({
                path: '/arguments',
                name: 'arguments',
                query: query
              });
            }

          }
        })
        .catch((err) => {});
    },

    // 处理买卖条件单
    setZdyBuyAndSelFunc: function () {
      var _this = this;
      _this.resetState(); //重置部分vuex
      let checkedYzList = [
        {
          ID: _this.basicsObj.zj_id,
          FactorName: '[' + _this.basicsObj.ts_name + ']策略因子',
          RiZhangFu: 0,
          XinHaoShuLiang: 0,
          XiFenZhongLei: '因子策略',
          ClassName: '因子策略',
          ProductType: '',
          Info: _this.mockHcInfo.f_id_arr,
          yzType: 7,
          isGz: false,
          Desc: _this.mockHcInfo.factorDesc
        }
      ];

      this.$store.commit('setCheckedYzList', checkedYzList); // 提交 mutation 来更新全局状态

      //  存储mock
      let mockData = _this.basicsObj;
      _this.$store.commit('setMockData', mockData);
    },
    // 设置Vuex的Obj数据
    serVuexObjData: function () {
      var _this = this;
      var vuexObj = {};
      if (_this.mockHcInfo.TradeRule == 0) {
        vuexObj = {
          holdPeriodList: _this.mockHcInfo.chigu_cycle,
          apiData: {},
          startDate: _this.mockHcInfo.starDate,
          endDate: _this.mockHcInfo.endDate,
          isCustomSelected: _this.mockHcInfo.chigu_type == 1 ? true : false,
          startMoney: _this.mockHcInfo.startMoney,
          PositionLimit: _this.mockHcInfo.posLimit,
          buyLimit: _this.mockHcInfo.buyLimit,
          sortKind: _this.mockHcInfo.sortKind,
          sortDirection: _this.mockHcInfo.sortDirection,
          stopProfitHigh: _this.mockHcInfo.stopProfitHigh,
          stopProfitLow: _this.mockHcInfo.stopProfitLow,
          stopLoss: _this.mockHcInfo.stopLoss,
          buyType: _this.mockHcInfo.buyType,
          type_info: _this.mockHcInfo.type_info, //因子类型 1A股 2etf
          isEdit: false,

          TradeRule: 0
        };
      } else if (_this.mockHcInfo.TradeRule == 1) {
        vuexObj = {
          holdPeriodList: _this.mockHcInfo.chigu_cycle,
          apiData: {},
          startDate: _this.mockHcInfo.starDate,
          endDate: _this.mockHcInfo.endDate,
          isCustomSelected: _this.mockHcInfo.chigu_type == 1 ? true : false,
          startMoney: _this.mockHcInfo.startMoney,
          PositionLimit: _this.mockHcInfo.posLimit,
          buyLimit: _this.mockHcInfo.buyLimit,
          sortKind: _this.mockHcInfo.sortKind,
          sortDirection: _this.mockHcInfo.sortDirection,
          stopProfitHigh: _this.mockHcInfo.stopProfitHigh,
          stopProfitLow: _this.mockHcInfo.stopProfitLow,
          stopLoss: _this.mockHcInfo.stopLoss,
          buyType: _this.mockHcInfo.buyType,
          type_info: _this.mockHcInfo.type_info, //因子类型 1A股 2etf
          isEdit: true,

          TradeRule: 1,
          RiskTemplate: _this.mockHcInfo.RiskTemplate, //  Int   风控模板 目前有6种，<br/>分别是 0:MACD仓控模板 1:均线模板<br/>2:成交额仓控模板 3:乖离仓控模板<br/>4:价格仓控模板 5:价格均线仓控模板

          MightyRiskPosition: _this.mockHcInfo.MightyRiskPosition, //float 强势风控仓位 eg:0.2就是20%--(TradeRule为1时传输)
          MightyStopProfitHigh: _this.mockHcInfo.MightyStopProfitHigh, //float 强势止盈卖出高水位线 eg:0.07就是7%--(TradeRule为1时传输)
          MightyStopProfitLow: _this.mockHcInfo.MightyStopProfitLow, //float 强势止盈卖出低水位线(止盈回撤线) eg:0.01就是1%--(TradeRule为1时传输)
          MightyStopLoss: _this.mockHcInfo.MightyStopLoss, //float 强势止损卖出水位线 eg:-0.05就是-5%--(TradeRule为1时传输)

          WeaknessRiskPosition: _this.mockHcInfo.WeaknessRiskPosition, //float 弱势风控仓位 eg:0.2就是20%--(TradeRule为1时传输)
          WeaknessStopProfitHigh: _this.mockHcInfo.WeaknessStopProfitHigh, //float 弱势止盈卖出高水位线 eg:0.07就是7%--(TradeRule为1时传输)
          WeaknessStopProfitLow: _this.mockHcInfo.WeaknessStopProfitLow, //float 弱势止盈卖出低水位线(止盈回撤线) eg:0.01就是1%--(TradeRule为1时传输)
          WeaknessStopLoss: _this.mockHcInfo.WeaknessStopLoss, //float 弱势止损卖出水位线 eg:-0.05就是-5%--(TradeRule为1时传输)

          VibrateRiskPosition: _this.mockHcInfo.VibrateRiskPosition, //float 震荡风控仓位 eg:0.2就是20%--(TradeRule为1时传输)
          VibrateStopProfitHigh: _this.mockHcInfo.VibrateStopProfitHigh, //float 震荡止盈卖出高水位线 eg:0.07就是7%--(TradeRule为1时传输)
          VibrateStopProfitLow: _this.mockHcInfo.VibrateStopProfitLow, //float 震荡止盈卖出低水位线(止盈回撤线) eg:0.01就是1%--(TradeRule为1时传输)
          VibrateStopLoss: _this.mockHcInfo.VibrateStopLoss //float 震荡止损卖出水位线 eg:-0.05就是-5%--(TradeRule为1时传输)
        };
      }
      _this.$store.commit('setObj', vuexObj);
    },
    // 点击跳转去实盘
    goRealUrl: function () {
      // 根据不同的券商获取不同的跳转地址
      var _this = this;
      // 判断类型
      if (_this.basicsObj.tag_type > 1 && _this.basicsObj.tag_type < 5) {
        // 券商跳转
        // 读取配置文件中的券商开户与跳转地址
        var qsList = window.MNDETAIL_QSLIST;
        // 查询qsList中value等于tag_type的券商信息
        _this.targetQs = qsList.find(function (item) {
          return item.value === _this.basicsObj.tag_type;
        });

        _this.realShow = true;
      } else if (_this.basicsObj.isMn == true) {
        // 我自己的实盘
        _this.realMeShow = true;
      } else {
        // 其他情况
      }
    },
    goRealOpenUrl: function (value) {
      var _this = this;
      if (value == 0) {
         this.$toast('暂不支持');
        return;
        // window.location.href = _this.targetQs.resurl;
      } else {
        window.location.href = _this.targetQs.openurl+"&zj_id="+_this.basicsObj.zj_id;
      }
    },
    // 点击确认按钮
    openDialogConfirm: function (value) {
      var _this = this;
      var params = {
        zj_id: _this.basicsObj.zj_id,
        open_status: value
      };
      updatePublicOpen(params)
        .then((result) => {
          _this.openDialog = false;
          _this.popupShow = false;
          if (result.err == 200) {
            if (value == 1) {
              _this.$toast('策略已公开');
            } else {
              _this.$toast('策略已取消公开');
            }

            _this.basicsObj.public_open = value;
          } else {
            _this.$toast(result.msg);
          }
        })
        .catch((err) => {
          _this.$toast('策略设置失败');
        });
    },
    // 点击去开户跳转
    goRealMeOpenUrl: function (url,name) {
      if(name == '湘财证券') {
        this.$toast('暂不支持');
        return;
      }
      window.location.href = url;
    },
    // 点击去我的实盘按钮
    goRealMeUrl: function (key) {
      var _this = this;
      window.location.href = _this.realMeList[key].link;
    },
    // 点击跳转用户中心
    gotoUserHome: function (userid) {
        var _this = this;
        window.location.href = "dzh_browser_url&goto=0&screen=252&userId=" + userid;
    },
  },
  beforeDestroy() {
    let that = this;
    that.$watermark.set('', that.$refs.watermarkBox);
    // window.clearInterval(that.hotTacticInterval);
    // that.hotTacticInterval = null;
    window.removeEventListener('scroll', this.allPageScroll, true);
    window.removeEventListener('resize', this.resizeHandler);
  },

};
</script>
<style lang="less" scoped>
.hot_page {
  width: 100%;
  height: 100%;
  -webkit-overflow-scrolling: touch;

  .sticky_header {
    .navg_box {
      background: linear-gradient(198.51deg, #4478ff -5%, rgba(239, 242, 250, 1) 95%);
      padding-top: 0;
      .bg_box {
        width: 100%;
        height: 100%;
        padding-top: 44px;
        background: url('../../assets/image/detail_top.png') top no-repeat;
        background-size: 100% 170px;
      }
    }
  }
  .navg_box {
    width: 100%;
    padding-top: 0px;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 99;
    .bg_box {
      padding-top: 44px;
    }
  }
  header {
    width: 100%;
    background: linear-gradient(198.51deg, #4478ff -6.42%, rgba(239, 242, 250, 0.4) 83.87%);
    .header_main {
      padding-top: 88px;
      background: url(../../assets/image/detail_top.png) no-repeat;
      background-size: 56vh;
    }
    .hd_main {
      padding: 0 16px;
      padding-bottom: 25px;
      box-sizing: border-box;
      .cl_tit_main {
        width: 100%;
        height: 46px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        .text {
          font-size: 20px;
          font-weight: bold;
          color: #373a4d;
          .sub_icon {
            width: 24px;
            height: 14px;
            display: inline-block;
            background: url('../../assets/image/cjts_icon.png') no-repeat;
            background-size: 100% 100%;
          }
          .mock-status-run {
            border: 1px solid #5585e4;
            font-size: 12px;
            color: #4177e4;
            border-radius: 12px;
            padding: 2px 6px;
          }
          .mock-status-end {
            border: 1px solid #7d7d7d;
            font-size: 12px;
            color: #7d7d7d;
            border-radius: 12px;
            padding: 2px 6px;
          }
        }
        img {
          width: 24px;
          height: 24px;
        }
        .btn {
          width: 60px;
          height: 30px;
          background: #286df7;
          border-radius: 4px;
          line-height: 30px;
          text-align: center;
          color: #fff;
          &.ygzBtn {
            background: rgba(40, 109, 247, 0.2);
            color: #286df7;
          }
        }
      }
      .Trading_type {
        margin-bottom: 12px;
        .under_way {
          display: flex;
          flex-wrap: wrap;
          span {
            border-radius: 17px;
            background: rgba(17, 75, 224, 0.5);
            padding: 4px 6px;
            align-items: center;
            color: #fff;
            font-size: 12px;
            font-weight: 400;
            margin-right: 4px;
            margin-bottom: 5px;
            &.jinx {
              padding-left: 13px;
              position: relative;
              &::before {
                content: ' ';
                width: 3px;
                height: 3px;
                border-radius: 50%;
                position: absolute;
                top: 50%;
                left: 6px;
                background-color: #fff;
                transform: translate(0, -50%);
              }
            }
          }
          // span {
          //   display: inline-block;
          //   text-align: center;
          //   border-radius: 2px;
          //   font-size: 12px;
          //   margin-right: 4px;
          //   &.jinx {
          //     padding: 4px 6px;
          //     padding-left: 13px;
          //     color: #11af7e;
          //     background: #e2f7f2;
          //     // margin-right: 6px;
          //     position: relative;
          //     &::before {
          //       content: ' ';
          //       width: 3px;
          //       height: 3px;
          //       border-radius: 50%;
          //       position: absolute;
          //       top: 50%;
          //       left: 6px;
          //       background-color: #11af7e;
          //       transform: translate(0, -50%);
          //     }
          //   }
          //   &.zq_box {
          //     padding: 4px 6px;
          //     background-color: #fff1e3;
          //     color: #e78c31;
          //   }
          //   &.dp_box {
          //     padding: 4px 6px;
          //     background-color: #fff1e3;
          //     color: #e78c31;
          //   }
          // }
        }
        .close_box {
          width: 48px;
          height: 22px;
          line-height: 22px;
          background-color: #efefef;
          color: #7d7d7d;
          font-size: 12px;
          border-radius: 2px;
          text-align: center;
        }
      }
      .introduce_box {
        font-size: 12px;
        color: #666666;
        margin-bottom: 6px;
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        align-content: center;
        justify-content: flex-start;
        align-items: center;
        .introduce_box_avatar {
          width: 16px;
          height: 16px;
          border-radius: 50%;
          overflow: hidden;
          display: inline-block;
          margin-right: 4px;
          img {
            display: block;
            width: 100%;
            height: 100%;
          }
        }
        span {
          margin-left: 14px;
          position: relative;
          &::before {
            content: ' ';
            width: 1px;
            height: 6px;
            background-color: rgba(102, 102, 102, 0.6);
            position: absolute;
            top: 50%;
            left: -6px;
            transform: translate(0, -50%);
          }
        }
      }

      .text-wrapper {
        font-size: 14px;
        line-height: 1.5;
        color: #666666;
        margin-bottom: 10px;

        .text-content {
          &.collapsed {
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }

        .head-desc-but {
          color: #286df7;
          cursor: pointer;
          font-size: 14px;
          margin-left: 4px;
          text-align: right;
          display: block;
          &:hover {
            opacity: 0.8;
          }
        }
      }

      .msg_main {
        width: 100%;
        margin-bottom: 8px;
        background-color: #fff;
        border: 1px solid #ffffff;
        border-radius: 4px;
        ul {
          width: 100%;
          li {
            width: 33.33333333333333%;
            text-align: center;
            padding: 10px 0 12px 0;
            box-sizing: border-box;
            float: left;
            &:nth-child(1),
            &:nth-child(2) {
              position: relative;
              &::before {
                content: ' ';
                position: absolute;
                top: 50%;
                right: 0;
                transform: translate(0, -50%);
                width: 1px;
                height: 10px;
                background: rgba(153, 153, 153, 0.2);
              }
            }
            p {
              &:first-child {
                font-weight: 500;
                font-size: 14px;
                line-height: 20px;
                color: #373a4d;
              }
              &:last-child {
                font-size: 12px;
                color: #666666;
              }
            }
          }
        }
      }
      .divisor_main {
        margin-bottom: 0px;
        .yzc_list {
          ul {
            li {
              p {
                &:first-child {
                  font-size: 12px;
                  color: #666666;
                }
                &:last-child {
                  font-weight: 500;
                  font-size: 14px;
                  line-height: 20px;
                  color: #373a4d;
                }
              }
            }
            &:first-child {
              li {
                &:nth-child(2) {
                  &::before {
                    content: none;
                  }
                }
                &:nth-child(3) {
                  height: 62px;
                  position: relative;
                  .van-icon {
                    position: absolute;
                    top: 50%;
                    right: 16px;
                    transform: translate(0, -50%);
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  .contant_main {
    width: 100%;
    overflow: hidden;
    background: #fff;
    padding-top: 6px;
    background: linear-gradient(0deg, #4478ff 0, #eff2fa -119%);
    .main_all {
      border-radius: 8px 8px 0px 0px;
      overflow: hidden;
      background-color: #fff;
      .nav_list_main {
        width: 100%;
        height: 36px;
        // padding: 0 12px;
        box-sizing: border-box;
        li {
          width: 25%;
          text-align: center;
          line-height: 36px;
          font-size: 14px;
          color: #373a4d;
          display: inline-block;
          &:first-child {
            width: 21%;
          }
          &.active {
            position: relative;
            color: #286df7;
            font-weight: 600;
            &::before {
              content: ' ';
              position: absolute;
              left: 50%;
              bottom: 0;
              transform: translate(-50%, 0);
              width: 16px;
              height: 2px;
              border-radius: 4px;
              background: #286df7;
            }
          }
        }
      }
      .pj_main {
        padding: 16px;
        box-sizing: border-box;
        .tit_box {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 15px;
          p {
            font-weight: 600;
            font-size: 16px;
            color: rgba(0, 0, 0, 0.9);
          }
        }
        .intro_text {
          font-size: 14px;
          line-height: 22px;
          color: #373a4d;
          margin-bottom: 16px;
        }
        .xx_list {
          width: 100%;
          text-align: center;
          ul {
            width: 100%;
            display: flex;
            li {
              width: 109px;
              padding: 12px;
              background-color: #f7f8fa;
              margin-right: 8px;
              border-radius: 6px;
              p {
                &:first-child {
                  font-size: 14px;
                  font-weight: 500;
                }
                &:last-child {
                  font-size: 12px;
                  color: #999;
                }
              }
              &:last-child {
                margin-right: 0;
              }
            }
          }
        }
      }
      .interval_box {
        width: 100%;
        height: 8px;
        background-color: #f8f9fc;
      }
      .sy_main {
        width: 100%;
        padding-bottom: 10px;
        .tit_box {
          width: 100%;
          padding: 8px 16px 4px 16px;
          font-size: 14px;
          color: #666666;
        }
        .cont_main {
          width: 100%;
          padding-top: 14px;
          .selice_main {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 23px;
            .left_btn_main {
              padding-left: 21px;
            }
            .right_selice {
              padding-right: 19px;
              position: relative;
              .selice_btn {
                padding: 2px 14px 2px 6px;
                box-sizing: border-box;
                background-color: #f5f6f9;
                border-radius: 6px;
                color: #373a4d;
                font-size: 12px;
                font-weight: 500;
                position: relative;
                &::before {
                  content: '';
                  position: absolute;
                  top: 9px;
                  right: 6px;
                  width: 0;
                  height: 0;
                  display: block;
                  border-left: 3px solid transparent;
                  border-right: 3px solid transparent;
                  border-top: 3px solid #333333;
                }
                &.active {
                  &::before {
                    transform: rotate(180deg);
                    top: 8px;
                  }
                }
              }
              .selice_box {
                position: absolute;
                right: 20px;
                top: 26px;
                z-index: 999;
                ul {
                  padding: 8px;
                  background: #ffffff;
                  border: 1px solid #e5e5e5;
                  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
                  border-radius: 6px;
                  box-sizing: border-box;
                  li {
                    padding: 8px 12px;
                    font-size: 14px;
                    color: #373a4d;
                    white-space: nowrap;
                    border-radius: 6px;
                    &.active {
                      background: #f7f7fc;
                      border: 1px solid #286df7;
                      color: #286df7;
                    }
                  }
                }
              }
            }
          }
          .line_box {
            width: 334px;
            height: 200px;
            margin: 0 auto;
          }
          .tab_cont_box {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            padding-left: 30px;
            span {
              color: #373a4d;
              font-size: 14px;
              line-height: 20px;
              &:first-child {
                margin-right: 38px;
                position: relative;
                &:before {
                  content: ' ';
                  position: absolute;
                  top: 8px;
                  left: -22px;
                  width: 16px;
                  height: 6px;
                  background: linear-gradient(
                    rgba(40, 109, 247, 1) 10%,
                    rgba(40, 109, 247, 0.2) 90%
                  );
                }
              }
              &:nth-child(2) {
                position: relative;
                margin-right: 38px;
                &:before {
                  content: ' ';
                  position: absolute;
                  top: 8px;
                  left: -22px;
                  width: 16px;
                  height: 6px;
                  background: linear-gradient(
                    rgba(255, 145, 83, 1) 10%,
                    rgba(247, 152, 40, 0.2) 90%
                  );
                }
              }
              &:nth-child(3) {
                position: relative;
                &:before {
                  content: ' ';
                  position: absolute;
                  top: 8px;
                  left: -22px;
                  width: 17px;
                  border-bottom: 1px dashed rgba(0, 0, 0, 0.3);
                }
              }
            }
          }
        }
      }
      .table_main {
        width: 100%;
        .tit_box {
          width: 100%;
          padding: 15px 16px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          .name_box {
            color: rgba(55, 58, 77, 0.9);
            font-size: 16px;
            font-weight: 600;
          }
          .time_box {
            color: #999;
            font-size: 12px;
          }
        }
        .nav_box {
          width: 100%;
          padding: 4px 12px;
          box-sizing: border-box;
          min-height: 34px;
          div {
            display: inline-block;
            width: 80px;
            height: 25px;
            text-align: center;
            line-height: 25px;
            border-radius: 4px;
            border: 1px solid #f5f6f9;
            font-size: 12px;
            color: #555555;
            &:first-child {
              margin-right: 8px;
            }
            &.active {
              background: rgba(40, 109, 247, 0.1);
              border: none;
              color: #286df7;
              font-weight: 500;
            }
          }
        }
        .table_content {
          width: 100%;
          table {
            th {
              font-size: 12px;
              color: #999999;
              font-weight: 400;
              padding: 4px 0;

              &:first-child {
                padding-left: 15px;
                box-sizing: border-box;
                text-align: left;
                width: 25%;
              }
              &:last-child {
                padding-right: 15px;
                box-sizing: border-box;
                text-align: right;
                width: 20%;
              }
            }
            td {
              height: 57px;
              text-align: center;
              font-size: 12px;
              color: #373a4d;
              &:first-child {
                padding-left: 15px;
                width: 25%;
                p {
                  text-align: left;
                  &:first-child {
                    margin-bottom: 4px;
                  }
                }
              }
              &:nth-child(2) {
                // padding-left: 17px;
                width: 20%;
                font-size: 11px;
                // text-align: left;
                text-align: center;
                p {
                  &:first-child {
                    font-size: 14px;
                    font-weight: 600;
                  }
                  &:last-child {
                    font-size: 12px;
                    color: #999;
                  }
                }
              }
              .business {
                display: inline-block;
                padding: 2px 4px;
                box-sizing: border-box;
                font-size: 11px;
                background-color: rgba(239, 57, 57, 0.1);
                color: #ef3939;
              }
              .businesssell {
                display: inline-block;
                padding: 2px 4px;
                box-sizing: border-box;
                font-size: 11px;
                background-color: rgba(30, 172, 78, 0.1);
                color: #1eac4e;
                border-radius: 2px;
              }
            }
          }
        }
        &.ccxq {
          padding-bottom: 8px;
          table {
            td {
              &:last-child {
                padding-left: 10px;
                text-align: left;
                font-size: 12px;
                p {
                  &:first-child {
                    color: #373a4d;
                  }
                  &:last-child {
                    color: #999;
                  }
                }
              }
            }
          }
        }
        &.tcjl {
          table {
            td {
              &:nth-child(3) {
                p {
                  &:first-child {
                    font-size: 14px;
                    color: #373a4d;
                  }
                  &:last-child {
                    color: #999;
                  }
                }
              }
            }
          }
        }
        .more_btn {
          width: 343px;
          height: 33px;
          text-align: center;
          line-height: 33px;
          border-radius: 4px;
          background: rgba(40, 109, 247, 0.06);
          font-size: 12px;
          color: #286df7;
          margin: 0 auto;
        }
        .statement_box {
          width: 359px;
          margin: 0 auto;
          padding: 8px 10px;
          border-radius: 6px;
          background: #f7f7fc;
          font-size: 10px;
          color: #999;
          margin-bottom: 8px;
          .tit {
            color: #555;
          }
        }
      }
      .blank_div {
        display: block;
        height: 90px;
      }
    }
  }

  // 页面滚动时触发的样式
  .contant_main {
    &.scrollBox {
      .main_all {
        padding-top: 36px;
        .nav_list_main {
          position: fixed;
          top: 88px;
          left: 0;
          background-color: #fff;
          z-index: 99;
          border-radius: 8px 8px 0px 0px;
        }
      }
      .scroll_nav_box {
        position: fixed;
        top: 124px;
        left: 0;
        background-color: #fff;
        z-index: 99;
      }
    }
  }
  .popup_box {
    width: 100%;
    padding-top: 20px;
    box-sizing: border-box;
    .controls_ul {
      width: 100%;
      // margin-bottom: 28px;
      li {
        display: inline-block;
        width: 100%;
        height: 50px;
        line-height: 50px;
        padding-left: 16px;
        font-size: 16px;
        color: #555;
        border-bottom: 1px solid #e5e5e5;
        &:last-child {
          border: none;
        }
      }
    }
    .close_box {
      width: 100%;
      height: 50px;
      border-top: 1px solid #e5e5e5;
      text-align: center;
      line-height: 50px;
      color: #555;
      font-size: 16px;
    }
  }
}
.black_version {
  min-height: 100vh;
  background-color: #0c0f13;
  .sticky_header {
    .navg_box {
      background: url('../../assets/image/blockImg/bg.png') top no-repeat;
      background-size: 100%;
      .bg_box {
        background: url('../../assets/image/detail_top.png') top no-repeat;
        background-size: 100% 4.2rem;
      }
    }
  }
  header {
    background: url('../../assets/image/blockImg/bg.png') top no-repeat;
    background-size: 100%;
    .navget_main {
      color: #e4e9fe;
    }
    .hd_main {
      .cl_tit_main {
        .text {
          color: #e4e9fe;
        }
      }
      .introduce_box {
        color: #aab9d1;
      }
      .msg_main {
        border: 1px solid rgba(255, 255, 255, 0.1);
        background: rgba(255, 255, 255, 0.1);
        ul {
          li {
            p {
              &:first-child {
                color: #e4e9fe;
              }
              &:last-child {
                color: #aab9d1;
              }
            }
          }
        }
      }
      .divisor_main {
        .tit_box {
          color: #e4e9fe;
        }
        .yzc_list {
          ul {
            li {
              i {
                color: #6b7687;
              }
              p {
                &:first-child {
                  color: #e4e9fe;
                }
                &:last-child {
                  color: #aab9d1;
                }
              }
            }
          }
        }
      }
    }
  }
  .contant_main {
    background: #0c0f13;
    .main_all {
      background-color: #181a23;
      .interval_box {
        background-color: #0c0f13;
      }
      .nav_list_main {
        li {
          color: #e4e9fe;
          &.active {
            color: #3b85fe;
            &::before {
              background: #3b85fe;
            }
          }
        }
      }
      .pj_main {
        .tit_box {
          p {
            color: #fff;
          }
        }
        .xx_list {
          ul {
            li {
              background-color: #1d202d;
              p {
                &:last-child {
                  color: #6b7687;
                }
              }
            }
          }
        }
      }
      .sy_main {
        .tit_box {
          color: #aab9d1;
        }
        .cont_main {
          .selice_main {
            .right_selice {
              .selice_btn {
                background-color: rgba(255, 255, 255, 0.06);
                color: #e4e9fe;
                &::before {
                  border-top: 0.08rem solid #e4e9fe;
                }
              }
              .selice_box {
                ul {
                  border: 1px solid rgba(255, 255, 255, 0.1);
                  background: #181a23;
                  box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.1);
                  li {
                    color: #e4e9fe;
                    &.active {
                      border: 0.5px solid #3b85fe;
                      background: #1d202d;
                      color: #3b85fe;
                    }
                  }
                }
              }
            }
          }
          .tab_cont_box {
            span {
              color: #e4e9fe;
              &:nth-child(3):before {
                border-bottom: 1px dashed rgba(250, 250, 250, 0.83);
              }
            }
          }
        }
      }
      .table_main {
        .tit_box {
          .name_box {
            color: #e4e9fe;
          }
          .time_box {
            color: #6b7687;
          }
        }
        .statement_box {
          background-color: #1d202d;
          color: #6b7687;
          .tit {
            color: #aab9d1;
          }
        }
        .table_content {
          table {
            th {
              color: #6b7687;
            }
            td {
              color: #e4e9fe;
              &:nth-child(2) {
                p {
                  &:last-child {
                    color: #6b7687;
                  }
                }
              }
              .businesssell {
                background-color: rgba(11, 175, 128, 0.2);
                color: #0baf80;
              }
              .business {
                background-color: rgba(239, 57, 57, 0.2);
                color: #ef3939;
              }
            }
          }
        }
        .nav_box {
          div {
            border: 1px solid rgba(255, 255, 255, 0.1);
            color: #aab9d1;
            &.active {
              background-color: rgba(40, 109, 247, 0.1);
              color: #3b85fe;
            }
          }
        }
      }
    }
    &.scrollBox {
      .main_all {
        .nav_list_main {
          background-color: #181a23;
        }
        .scroll_nav_box {
          background-color: #181a23;
        }
      }
    }
  }
  .popup_box {
    .controls_ul {
      li {
        color: #aab9d1;
        border-bottom: 1px solid rgba(255, 255, 255, 0.1);
      }
    }
    .close_box {
      border-top: 1px solid rgba(255, 255, 255, 0.1);
      color: #aab9d1;
    }
  }
  .under_way {
    span {
      border: 0.5px solid #fff;
      box-shadow: 0px 4px 5px -2px rgba(0, 0, 0, 0.05);
      background: rgba(17, 75, 224, 0) !important;
    }
  }
}
</style>
<style lang="less">
.left_btn_main {
  .van-checkbox__icon {
    height: 16px;
  }
  .van-icon {
    width: 16px;
    height: 16px;
    border-radius: 2px;
  }
  .van-checkbox__icon .van-icon {
    font-size: 0.7em;
    line-height: 1.2;
  }
}
.black_version {
  .left_btn_main {
    .van-checkbox__label {
      color: #aab9d1 !important ;
    }
    .van-checkbox__icon--checked {
      .van-icon {
        background-color: #3b85fe;
        border-color: #3b85fe;
        color: #181a23;
      }
    }
  }
}

.dialog_box {
  .van-dialog__confirm,
  .van-dialog__confirm:active {
    color: #999999 !important;
  }
}

// 遮罩
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
.van-overlay {
  z-index: 999;
}

// 悬浮按钮
.btn_box {
  // 悬浮在屏幕底部
  position: fixed;
  bottom: 34px;
  left: 0;
  right: 0;
  padding: 0 16px;

  // 券商类型按钮
  .btn_box_qs {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: space-between;
    gap: 10px;
    .box_qs_item {
      width: 48%;
      border-radius: 88px;
    }
    .box_qs_item_zdy {
      border: 1px solid #286df7;
      color: #286df7;
      font-size: 16px;
      font-weight: 500;
    }
    .box_qs_item_qs {
      background: #286df7;
      color: #ffffff;
      font-size: 16px;
      font-weight: 500;
      border: 1px solid #286df7;
    }
  }

  .btn_zdy_box {
    background: #286df7;
    width: 100%;
    font-weight: 500;
    color: #ffffff;
    font-size: 16px;
    border-radius: 88px;
    border: 1px solid #286df7;
  }
}

// 量化信息弹窗
.lhhc-info {
  padding: 12px;
  padding-top: 20px;
  background: linear-gradient(217.04deg, #4478ff -6.67%, rgba(239, 242, 250, 0.4) 84.67%);
  .lhhc-factor {
    .lhhc-factor-title {
      font-size: 14px;
      font-weight: 700;
      color: #286df7;
    }
    .lhhc-factor-name {
      padding: 10px 12px;
      border-radius: 4px;
      background: #ffffff;
      border: 1px solid;
      border-color: rgba(255, 255, 255, 0.8);
      margin-top: 6px;
      margin-bottom: 6px;
      font-size: 12px;
      font-weight: 500;
      color: rgba(55, 58, 77, 0.9);
    }
    .lhhc-factor-list {
      color: #444444;
      font-size: 12px;
    }
  }
  // 交易参数
  .lhhc-jycs {
    height: 320px;
    overflow: hidden;
    overflow-y: auto;
  }
  // 点击按钮
  .lhhc-jycs-btn {
    height: 36px;
    display: flex;
    gap: 8px;
    margin-bottom: 14px;
    margin-top: 12px;
    .lhhc-jycs-btn-style {
      width: 100%;
      max-height: 36px;
      font-size: 14px;
      color: #ffffff;
      background: #286df7;
      border-radius: 6px;
      border: 1px solid #286df7;
    }
    .lhhc-jycs-btn-style::before {
      border: 1px solid #286df7;
      content: "";
      background: linear-gradient(-65deg, #0000 40%, #fff7 50%, #0000 70%);
      background-size: 200% 100%;
      background-repeat: no-repeat;
      animation: thing 3s ease infinite;
    }
    @keyframes thing {
    0% {
      background-position: 130%;
      opacity: 1;
    }

    to {
      background-position: -166%;
      opacity: 0;
    }
  }
  }
}

// 跳转实盘弹窗
.real_box_dialog {
  .real_box {
    padding: 20px;
    .real_box_title {
      color: #1d2129;
      font-size: 15px;
    }
    .real_box_img {
      height: 228px;
      margin-top: 10px;
      img {
        display: inline-block;
        width: 100%;
        height: 100%;
      }
    }
    .real_box_but {
      margin-top: 20px;
      .real_box_but_res {
        width: 100%;
        height: 50px;
        color: #fff;
        font-size: 16px;
        background-color: #286df7;
        border-radius: 6px;
        border: 0px solid;
        margin-bottom: 12px;
      }
      .real_box_but_text {
        text-align: center;
        font-size: 15px;
        color: #286df7;
      }
    }
  }
}

// 关闭按钮
.real_box_close {
  width: 33px;
  height: 33px;
  position: fixed;
  top: calc(45% + 200px + 20px);
  left: 50%;
  transform: translateX(-50%);
  z-index: 10000;

  .real_box_close_img {
    display: inline-block;
    width: 100%;
    height: 100%;
  }
}

// 公开弹窗
.open_dialog {
  .open_dialog_content {
    .open_dialog_top {
      height: 66px;
      img {
        display: inline-block;
        width: 100%;
        height: 100%;
      }
    }
    .open_dialog_bottom {
      padding: 24px 20px;
      .open_dialog_bottom_title {
        text-align: center;
        color: rgba(0, 0, 0, 0.9);
        font-size: 16px;
        font-weight: 500;
      }
      .open_dialog_bottom_desc {
        color: rgba(0, 0, 0, 0.6);
        font-size: 14px;
        text-align: center;
        text-align: center;
      }
      .open_dialog_bottom_btn_box {
        margin-top: 16px;
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        justify-content: space-between;
        gap: 10px;
        .open_dialog_bottom_btn {
          width: 48%;
          height: 40px;
          border-radius: 6px;
          font-size: 16px;
          font-weight: 600;
        }
        .open_dialog_bottom_btn_cancel {
          background: #f2f3ff;
          color: #286df7;
          border: 1px solid #f2f3ff;
        }
        .open_dialog_bottom_btn_confirm {
          background: #286df7;
          color: #fff;
          border: 1px solid #286df7;
        }
      }
    }
  }
}

// 我的实盘弹窗
.real_me_box_info {
  padding: 16px 20px;
  .box_info {
    .box_info_top {
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      align-content: center;
      justify-content: space-between;
      align-items: center;
      .box_info_top_icon {
        width: 20px;
        height: 20px;
      }
      .box_info_top_text {
        font-weight: 500;
        color: #4e5969;
        font-size: 17px;
        text-align: center;
      }
    }
    .box_info_list {
      // border: 1px solid red;
      margin-top: 20px;
      .box_info_item {
        padding: 12px 16px;
        background: #f8f8fc;
        border-radius: 6px;
        border: 1px solid #f8f8fc;
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        align-content: center;
        justify-content: space-between;
        align-items: center;
        margin-top: 8px;
        .box_info_item_icon {
          width: 24px;
          height: 24px;
          img {
            width: 100%;
            height: 100%;
            display: block;
          }
        }
        .box_info_item_qs {
          .box_info_item_qs_name {
            display: flex;
            flex-direction: row;
            flex-wrap: nowrap;
            align-content: center;
            justify-content: flex-start;
            align-items: center;
            .box_info_item_qs_name_icon {
              width: 20px;
              height: 20px;
              margin-right: 10px;
              img {
                display: block;
                width: 100%;
                height: 100%;
              }
            }
            .box_info_item_qs_name_text {
              font-weight: 500;
              color: #1d2129;
              font-size: 16px;
            }
          }
          .box_info_item_qs_desc {
            color: #949da8;
            font-size: 12px;
            margin-top: 11px;
          }
        }
      }
      .box_info_item_active {
        background: linear-gradient(254.25deg, #e9f0fe -0.19%, #f4f8ff 99.13%);
        border: 1px solid #286df7;
        .box_info_item_qs {
          .box_info_item_qs_desc {
            color: #254fa2;
          }
        }
      }
    }
    .box_info_btn {
      width: 100%;
      background: #286df7;
      border-radius: 8px;
      margin-top: 20px;
      height: 43px;
      line-height: 43px;
      text-align: center;
      color: #fff;
    }
  }
}

// 黑版弹窗
.black_version {
  // 量化信息弹窗
  .lhhc-info {
    background: linear-gradient(209.06deg, #2f5195 0.77%, #171922 27.14%);
    .lhhc-factor {
      .lhhc-factor-title {
        color: #3b85fe;
      }
      .lhhc-factor-name {
        color: #e4e9fe;
        background-color: rgba(255, 255, 255, 0.1);
        border: 1px solid;
        border-color: rgba(255, 255, 255, 0.1);
      }
      .lhhc-factor-list {
        color: #aab9d1;
      }
    }
    // 交易参数
    .lhhc-jycs {
      height: 320px;
      overflow: hidden;
      overflow-y: auto;
    }
    // 点击按钮
    .lhhc-jycs-btn {
      height: 36px;
      display: flex;
      gap: 8px;
      margin-bottom: 14px;
      margin-top: 12px;
      .lhhc-jycs-btn-style {
        width: 100%;
        max-height: 36px;
        font-size: 14px;
        color: #ffffff;
        background: #286df7;
        border-radius: 6px;
        border: 1px solid #286df7;
      }
    }
  }

  // 公开弹窗
  .open_dialog {
    .open_dialog_content {
      .open_dialog_bottom {
        .open_dialog_bottom_title {
          color: #e4e9fe;
        }
        .open_dialog_bottom_desc {
          color: #aab9d1;
        }
        .open_dialog_bottom_btn_box {
          .open_dialog_bottom_btn_cancel {
            background:rgba(59, 133, 254, 0.2);
            color: #3b85fe;
            border: 1px solid rgba(59, 133, 254, 0.2);
          }
          .open_dialog_bottom_btn_confirm {
            background: #3b85fe;
            color: #e4e9fe;
            border: 1px solid #3b85fe;
          }
        }
      }
    }
  }

  // 我的实盘弹窗
  .real_me_box_info {
    .box_info {
      .box_info_top {
        .box_info_top_text {
          color: #aab9d1;
        }
      }
      .box_info_list {
        .box_info_item {
          background: rgba(255, 255, 255, 0.03);
          border: 1px solid rgba(255, 255, 255, 0.03);
          .box_info_item_qs {
            .box_info_item_qs_name {
              .box_info_item_qs_name_text {
                color: #aab9d1;
              }
            }
            .box_info_item_qs_desc {
              color: #697689;
            }
          }
        }
        .box_info_item_active {
          background: rgba(59, 133, 254, 0.2);
          border: 1px solid #3b85fe;
          .box_info_item_qs {
            .box_info_item_qs_name {
              .box_info_item_qs_name_text {
                color: #e4e9fe;
              }
            }
            .box_info_item_qs_desc {
              color: #507ed8;
            }
          }
        }
      }
      .box_info_btn {
        background: #3b85fe;
      }
    }
  }


// 跳转实盘弹窗
.real_box_dialog {
  .real_box {
    .real_box_title {
      color: #e4e9fe;
    }
    .real_box_but {
      .real_box_but_res {
        color: #fff;
        background-color: #3b85fe;
      }
      .real_box_but_text {
        color: #3b85fe;
      }
    }
  }
}

}
</style>
